module.exports = __webpack_public_path__ + "static/media/nina_lunginbühl.3f639b3e.jpg";